import Swal from 'sweetalert2';
import { coresTemaSwal } from './toast';

// Vermelho é sempre o botão de recusar ou destruir. Em ação destrutiva
// (excluir, desativar) quem destrói é o confirmar; em ação positiva (liberar,
// aprovar, aplicar) o confirmar é verde e o vermelho fica com o cancelar — o
// operador lê a cor antes do texto, e confirmar vermelho parecia recusa.
const CORES_BOTOES = {
    perigo: { confirmButtonColor: '#C62828', cancelButtonColor: '#1565C0' },
    positivo: { confirmButtonColor: '#2E7D32', cancelButtonColor: '#C62828' },
};

// Confirmação padrão do sistema (SweetAlert2) — usar no lugar de Dialog
// para confirmações simples (exclusão, ações destrutivas; ação positiva passa
// tom: 'positivo'). Retorna true se o usuário confirmou.
export const confirmar = ({
    titulo = 'Tem certeza?',
    texto = '',
    textoConfirmar = 'Confirmar',
    icone = 'warning',
    tom = 'perigo',
}) =>
    Swal.fire({
        title: titulo,
        text: texto,
        icon: icone,
        showCancelButton: true,
        confirmButtonText: textoConfirmar,
        cancelButtonText: 'Cancelar',
        ...CORES_BOTOES[tom],
        reverseButtons: true,
        focusCancel: true,
        ...coresTemaSwal(),
    }).then((resultado) => resultado.isConfirmed);

export const confirmarExclusao = (texto) =>
    confirmar({ titulo: 'Confirmar exclusão', texto, textoConfirmar: 'Excluir' });

// Para cadastros com exclusão lógica (motorista, transportadora, variedade,
// impressora): o registro não é removido, só marcado inativo — título e botão
// não podem falar em "excluir" enquanto o texto explica que é reversível.
export const confirmarDesativacao = (texto) =>
    confirmar({ titulo: 'Confirmar desativação', texto, textoConfirmar: 'Desativar' });

// Confirmação com campo de motivo (opcional por padrão; motivoObrigatorio
// exige preenchimento). Retorna { confirmado, motivo } — motivo null em branco.
export const confirmarComMotivo = ({
    titulo = 'Tem certeza?',
    texto = '',
    textoConfirmar = 'Confirmar',
    motivoObrigatorio = false,
    tom = 'perigo',
    placeholder = motivoObrigatorio ? 'Motivo (obrigatório)' : 'Motivo (opcional)',
}) =>
    Swal.fire({
        title: titulo,
        text: texto,
        icon: 'warning',
        input: 'text',
        inputPlaceholder: placeholder,
        inputValidator: motivoObrigatorio
            ? (valor) => (!valor || !valor.trim() ? 'Informe o motivo.' : undefined)
            : undefined,
        showCancelButton: true,
        confirmButtonText: textoConfirmar,
        cancelButtonText: 'Cancelar',
        ...CORES_BOTOES[tom],
        reverseButtons: true,
        ...coresTemaSwal(),
    }).then((resultado) => ({
        confirmado: resultado.isConfirmed,
        motivo: resultado.value?.trim() || null,
    }));
